<template>
  <div class="q-py-xl" style="max-width: 965px; margin: auto">
    <div v-if="business">
      <div class="row q-col-gutter-lg q-px-xl">
        <div class="col-auto">
          <q-img
            style="width: 150px; height: 100px"
            :src="business.imageUrl"
            contain
          >
          </q-img>
        </div>
        <div class="col">
          <h3 class="settingsHeader q-my-sm">Upload your Logo</h3>
          <p>Image may not exceed 2 MB</p>
          <q-btn
            label="Upload Image"
            class="bg-accent text-white"
            no-caps
            flat
            @click="changeImageDialog = true"
          ></q-btn>
        </div>
      </div>
      <div class="row q-col-gutter-md q-mt-lg">
        <div class="col-9">
          <span class="inputLabel"> Company Name </span>
          <q-input
            filled
            dense
            v-model="business.name"
            :rules="[(v) => !!v || 'Company Name is required']"
            required
          ></q-input>
        </div>
        <div class="col-3">
          <div class="col-12">
            <span class="inputLabel"> FTE </span>
            <q-input
              hint="How many Full Time Equivalent employees do you have? (FTE's is 30hrs+ p.w)"
              filled
              dense
              v-model="business.fte"
              type="number"
            ></q-input>
          </div>
        </div>
      </div>
      <div class="row q-mt-md">
        <div class="col-12 text-accent2">
          <b>Business Details</b>
        </div>
        <div class="col-12">
          <div style="min-height: 1px" class="bg-accent2"></div>
        </div>
        <hr />
      </div>
      <div class="row q-col-gutter-md q-mt-md">
        <div class="col-6">
          <span class="inputLabel"> Business Type </span>
          <q-select
            hint="What is your Business Type?"
            :options="[
              'Sole Trader',
              'Company',
              'Partnership / Joint Venture',
              'Charitable Trust',
              'Other',
            ]"
            filled
            dense
            v-model="business.sustainabilityBusinessType"
          ></q-select>
        </div>
        <div class="col-6">
          <span class="inputLabel"> Business Industry </span>
          <q-select
            hint="What is the Industry that best matches your organisation?"
            :options="[
              'Accommodation and Food Services',
              'Agriculture, Forestry and Fishing',
              'Arts and Recreation Services',
              'Construction',
              'Education and Training',
              'Electricity, Gas, Water and Waste Services',
              'Financial, Insurance & Administration Services',
              'Health Care and Social Assistance',
              'Information Media and Telecommunications',
              'Manufacturing',
              'Mining',
              'Professional, Scientific and Technical Services',
              'Rental, Hiring and Real Estate Services',
              'Retail Trade',
              'Transport, Postal and Warehousing',
              'Wholesale Trade',
              'Other',
            ]"
            filled
            dense
            v-model="business.sustainabilityBusinessIndustry"
          ></q-select>
        </div>
        <div class="col-6">
          <span class="inputLabel"> Website </span>
          <q-input filled dense v-model="business.website"></q-input>
        </div>
        <div class="col-6">
          <span class="inputLabel"> Email </span>
          <q-input filled dense v-model="business.email" readonly></q-input>
        </div>
        <div class="col-12">
          <span class="inputLabel"> Organisation locations </span>
          <q-input filled dense v-model="business.email" readonly></q-input>
        </div>
        <div class="col">
          <q-btn
            class="bg-positive text-white float-right"
            flat
            label="Save Changes"
            no-caps
            @click="save"
            :loading="saveLoading"
          ></q-btn>
        </div>
      </div>
    </div>
    <q-dialog v-model="changeImageDialog" persistent>
      <q-card
        class="card q-mx-auto"
        style="min-width: 610px; max-width: 610px"
        :style="cssVars"
      >
        <div class="row justify-between items-center q-px-md bg-accent2">
          <div class="text-white" style="font-size: 1rem; font-weight: 700">
            Please Upload an Image
          </div>
          <q-btn
            icon="mdi-close"
            flat
            round
            text-color="white"
            @click="changeImageDialog = false"
          >
          </q-btn>
        </div>
        <div class="row q-pa-md">
          <div class="col-12 text-accent text-center">
            <croppa
              ref="imgCroppa"
              :file-size-limit="3500000"
              :height="200"
              :width="300"
              v-model="myCroppa"
              remove-button-color="#68c6d2"
              :show-loading="true"
              :loading-size="50"
              crossOrigin="anonymous"
              :quality="2"
              :prevent-white-space="false"
              @file-size-exceed="fileSizeExceeded"
            ></croppa>
            <p>Max Size 3mb</p>
          </div>

          <div class="col-12 text-center q-mt-xl">
            <q-btn
              flat
              class="bg-accent text-white"
              style="width: 300px"
              no-caps
              @click="uploadImage"
              :loading="uploading"
            >
              Upload Image
            </q-btn>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters({
      userData: "auth/currentUserData",
      business: "business/current",
      businessLoading: "business/currentLoading",
    }),
  },
  data: () => ({
    changeImageDialog: false,
    myCroppa: null,
    uploading: false,
    saveLoading: false,
  }),
  mounted() {},
  methods: {
    async uploadImage() {
      if (!this.myCroppa) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "Please select an Image to upload",
        });
        return;
      }

      this.uploading = true;

      let payload = {
        dataUrl: this.myCroppa.generateDataUrl(),
      };

      try {
        let result = await this.$store.dispatch("business/updateLogo", payload);
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }

      this.uploading = false;
      this.changeImageDialog = false;
      this.myCroppa = null;
    },

    async save() {
      this.saveLoading = true;
      try {
        let result = await this.$store.dispatch("business/save", this.business);
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
      this.saveLoading = false;
    },
    fileSizeExceeded(val) {
      this.$q.notify({
        position: "top-right",
        type: "negative",
        message: "The Image must be a max of 3MB",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.settingsHeader {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.7rem;
}
</style>
